import { EDocumentRevisionStatus } from '@lib-shared/types/document-revision';
import type { IDocumentRevision } from '@signing-page/documents/types/document-revision';

export class RevisionHelper {
  static getLatestSealedRevision(revisions?: IDocumentRevision[]): IDocumentRevision {
    const sealedRevisions = revisions?.filter(
      revision => revision.status === EDocumentRevisionStatus.Sealed
    );
    if (sealedRevisions && sealedRevisions.length) {
      return sealedRevisions[sealedRevisions.length - 1];
    }
    return null;
  }
}
